export const experience = [
    "Less then 1 year",
    "1-3 years",
    "3-5 years",
    "5-10 years",
    "10+ years",
  ];